const bviPhotos = {
    id: 'pr-bvis-photos',
    type: 'photoPost',
    countryId: 'bvi',
    title: 'Best Of Puerto Rico & the BVIs in Photos',
    month: 'May',
    date: '29',
    content: [
       {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/pr1.jpg','https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/pr2.jpg'],
            detailText: 'Left, in one of the turrets at Castillo San Felipe del Morro in San Juan, Puerto Rico. Right, the colorful streets of San Juan.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/pr4.jpg',
            detailText: 'The view of San Juan\'s coast from the fort.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/pr3.jpg',
            detailText: 'The beautiful umbrella street!'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/pr5.jpg',
            detailText: 'Peter on the beach near our Airbnb.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi1.jpg',
            detailText: 'This and all the rest: the gorgeous British Virgin Islands, as seen from our catamaran! Peter\'s parents organized a trip for the week with friends from Michigan.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi2.jpg',
            detailText: 'No filter. It really is that turquoise.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi3.jpg',
            detailText: 'Left to right: Patty, me, Hilary (Peter\'s mom), and Ashley.'
        },
       {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi4.jpg','https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi5.jpg'],
            detailText: 'Running in the surf on Sandy Cay island.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi6.jpg',
            detailText: 'Sunset from anchorage off Norman island.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi7.jpg',
            detailText: 'Kayaking over the reef. We saw turtles!'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi8.jpg',
            detailText: 'Most of the Virgin Islands were destroyed by Hurricane Irma. A lot has been rebuilt, but some is still in ruins or temporary buildings.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi9.jpg'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi10.jpg'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi11.jpg',
            detailText: 'Sunrise in a bay.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi12.jpg',
            detailText: 'Washed up coral, and a fuzzy Brad and Kevin.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi13.jpg',
            detailText: 'Hilary and Alastair'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi14-1.jpg',
            detailText: 'Mugging'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi14.jpg',
            detailText: 'Currents were pretty strong if we took these floaties into the water, so they were enjoyed on top deck with a view.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/bvi/pr-bvis-photos/bvi15.jpg',
            detailText: 'Sums it up. This was taken at the end of an afternoon snorkeling with turtles, and we didn\'t realize everything on shore would close up! But we hitchhiked a ride back into town in a pickup truck.'
        }
]
}


export default bviPhotos


// WEBPACK FOOTER //
// ./src/Posts/Content/bviPhotos.js